<script setup lang="ts">
import SvgLoader from '@/utils/SvgLoader.vue';
import { computed, ref, StyleValue } from 'vue';
import { getRandomStr } from '@/businessRepository/idUtils';
import { INVENTORY_CONTROL_MENU_ITEMS } from '../constants/';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';

const props = defineProps<{ disabled?: boolean; toolTipMessage?: string }>();

/** Emits */
const emits = defineEmits<{
  (e: 'select', option: (typeof INVENTORY_CONTROL_MENU_ITEMS)[number]['value']): void;
}>();

/** Variables */
const t = i18n.t;
const containerId = getRandomStr(16);
const isMenuOpenedState = ref<boolean>(false);
const businessRowMenuButtonPosition = ref({
  x: 0,
  y: 0,
});

/** Function */
/**
 * ボタンクリック時orモーダル外をクリックした際の処理
 */
const onClickButton = () => {
  if (!isMenuOpenedState.value) {
    const buttonContent = document.getElementById(containerId);
    const bodyContent = document.getElementsByTagName('body')[0];
    if (!(buttonContent instanceof HTMLElement) || !(bodyContent instanceof HTMLElement)) return;
    businessRowMenuButtonPosition.value = {
      x: buttonContent.offsetWidth,
      y: buttonContent.getBoundingClientRect().top,
    };
  }
  isMenuOpenedState.value = !isMenuOpenedState.value;
};

const tableHeaderModifyMenuStyle = computed((): StyleValue => {
  return {
    top: `${businessRowMenuButtonPosition.value.y + 32}px`,
    right: `${businessRowMenuButtonPosition.value.x - 16}px`,
  };
});
/**
 * 選択肢を選んだ際の処理
 * @param value - 選択した値
 */
const selectOption = (value: (typeof INVENTORY_CONTROL_MENU_ITEMS)[number]['value']) => {
  isMenuOpenedState.value = false;
  emits('select', value);
};
</script>
<template>
  <div
    :id="containerId"
    v-tooltip.bottom="toolTipMessage"
    class="inventory-info-control-menu__button__container"
    :class="{ 'not-allow-cursor': disabled }"
  >
    <button
      class="inventory-info-control-menu__button"
      :class="{ 'inventory-info-control-menu__button--active': isMenuOpenedState, 'disabled-event': disabled }"
      @click="onClickButton"
    >
      <Mdi class="inventory-info-control-menu__button-icon" icon="more_horiz" />
    </button>
  </div>
  <Teleport v-if="isMenuOpenedState" to="body">
    <div class="inventory-info-control-menu__bg" @click="onClickButton" />
    <div class="inventory-info-control-menu__dropdown" :style="tableHeaderModifyMenuStyle">
      <div v-for="option in INVENTORY_CONTROL_MENU_ITEMS" :key="option.value" class="inventory-info-control-menu__content">
        <button
          :class="'inventory-info-control-menu__option inventory-info-control-menu__option--active'"
          @click="selectOption(option.value)"
        >
          <Mdi class="inventory-info-control-menu__icon" :icon="option.icon" />
          <div class="inventory-info-control-menu__option--text">{{ t(option.text) }}</div>
        </button>
      </div>
    </div>
  </Teleport>
</template>
<style lang="scss" scoped>
@import '@/InventoryControlModule/pages/scss/inventory-table.scss';
</style>
